module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/third-party.b1d223cb.svg";